<template>
  <div class="div-transfer-payment">
    <el-row>
      <el-col :span="10">
        <span>{{$t("tip.payment_currency")}}（{{currencyZhName}}）</span>
      </el-col>
      <el-col>
        <!-- size="small" -->
        <el-select
          v-model="coinPriceForm.convert"
          default-first-option
          :popper-append-to-body="false"
          @change="onConvertChange()"
          >
            <el-option v-for="(item, index) in usdt2FiatCurrencyRateEntityList" 
              :key="index" 
              :label="item.symbol" 
              :value="item.symbol" 
              :selected="item.symbol === coinPriceForm.convert" />
        </el-select>
      </el-col>
      
    </el-row>
    <span class="balance">{{showBalance}}</span>

    <el-row>
      <el-col :span="6">
        <span>{{$t("tip.payment_amount")}}</span>
      </el-col>
      
      <el-input
        v-model="transferForm.money"
        placeholder="输入金额"
        clearable
        size="medium"
      />
    </el-row>
    <el-row>
      <el-col :span="6">
        <span>收款地址</span>
      </el-col>
      <el-col :span="16">
        <el-input 
          placeholder="收款人地址" 
          v-model="transferForm.address" 
          class="input-with-select"
          size="medium">  
        </el-input>
      </el-col>
      <el-col>
        <el-button type="primary" icon="el-icon-camera" @click="onScanQRcode()">扫码</el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="6">
        <span>支付备注</span>
      </el-col>
      <el-col :span="16">
        <el-input
          v-model="transferForm.memo"
          placeholder="(默认自动填写ZNL价格，支付ZNL数量和对应币种金额)"
          clearable
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 2}"
        />
      </el-col>

    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="12">
        <el-button type="primary" @click="onPay()">支付</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { fetchCoinPrice, fetchUsdtFiatCurrencyRateList } from '@/api/wallet'
import BigNumber from 'bignumber.js';
import ScatterJS from "@scatterjs/core";
import ScatterEOS from "@scatterjs/eosjs2";
import { JsonRpc, Api } from "eosjs";
import VConsole from "vconsole";
import tp from "tp-js-sdk";
import { Message } from 'element-ui';
import { isNumberStr, isString } from '@/utils/validate';
import TokenWebView from '@consenlabs-fe/webview'

// if(process.env.NODE_ENV !== 'production') {
  var vConsole = new VConsole();
// }

const network = ScatterJS.Network.fromJson({
  blockchain: "eos",
  chainId: "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906",
  host: "eos.greymass.com",
  port: 443,
  protocol: "https"
});

const rpc = new JsonRpc(network.fullhost());

let scatter = "";
let api = "";

ScatterJS.plugins(new ScatterEOS());

export default {
  name: "TransferPayment",
  data() {
    return {

      contract: "zntzcontract",
      symbol: 'ZNL',
      decimals: 8,
      currentAccount: "",
      currencyZhName: "人民币",
      currentPermission: "",
      currentPublicKey: "",
      currentBalance: "",
      showBalance: "0.0",
      // currentSign: "",
      coinPriceEntity: {
        coin: 'ZNL',
        price: '0',
        convert: 'CNY',
        usdtPrice: '',
      },
      coinPriceForm: {
        coin: 'ZNL',
        convert: 'CNY',
      },
      
      transferForm: {
        address: '',
        money: '',
        memo: '',
      },

      /**
       * name : Chinese Yuan  法币名称
       * zhName : 人民币       法币中文名称
       * sign : ¥             法币符号
       * symbol : CNY         法币缩写
       * price : 6.70         兑换汇率
       */
      usdt2FiatCurrencyRateEntityList: [],
    };
  },
  created() {
    console.log('transferPayment created');
    console.log('tp isConnected:'+ tp.isConnected());
    
    this.connect()

    // 初始化获取服务相关数据
    this.getCoinPrice(this.coinPriceForm)
    this.getUsdtFiatCurrencyRateList()
    
  },

  computed: {
    
  },

  methods: {
    connect: function() {
      ScatterJS.scatter.connect("znl-dapp").then(connected => {
        if (!connected) {
          alert("no connect");
          return false;
        }
        console.log('wallet connected:');
        scatter = ScatterJS.scatter;
        this.login();
      })
      .catch(err => {
        var errLog = JSON.stringify(err)
        alert(errLog);
        console.error("connect error: " + errLog);
      });
    },

    logout: function() {
      if (!this.currentAccount) {
        alert("login first");
        return;
      }
      scatter.logout().then(a => alert(a))
      .catch(err => {
        var errLog = JSON.stringify(err)
        alert(errLog);
        console.error("connect error: " + errLog);
      });
    },
    login: function() {
      scatter
        .login()
        .then(id => {
          const account = scatter.identity.accounts.find(
            x => x.blockchain === "eos"
          );

          this.currentAccount = account.name;
          this.currentPermission = account.authority;
          this.currentPublicKey = account.publicKey;

          console.log("login get account:" + JSON.stringify(account));

          api = scatter.eos(network, Api, { rpc });

          this.getEosBalance(this.currentAccount, this.contract, this.symbol)

        })
        .catch(error => {
          var errLog = JSON.stringify(err)
          alert(errLog);
          console.error("login error: " + errLog);
        });
    },

    calcBalance: function() {
      if(this.currentBalance === '' || this.coinPriceEntity.price === '0'){
        return
      }
      console.log('balance='+ this.currentBalance + ', price=' + this.coinPriceEntity.price + ",convert=" + this.coinPriceEntity.convert);
      var str = ''
      this.usdt2FiatCurrencyRateEntityList.forEach(element => {
          if(element.symbol === this.coinPriceEntity.convert) {
            var bigAmount = new BigNumber(this.currentBalance).multipliedBy(this.coinPriceEntity.price).toFixed(4, 1)
            str = "Balance≈" + element.sign + bigAmount
            this.currencyZhName = element.zhName
          }
      });
      console.log('computed balance:'+ str);
      this.showBalance = str;
    },

    getCoinPrice(data) {
      fetchCoinPrice(data).then(response => {
        console.log("fetchCoinPrice: " + JSON.stringify(response));
        this.coinPriceEntity = response.data
        this.calcBalance()
      })
      .catch(err => {
        var errLog = JSON.stringify(err)
        alert(errLog);
        console.error("getCoinPrice error: " + errLog);
      });
    },
    
    getUsdtFiatCurrencyRateList() {
      fetchUsdtFiatCurrencyRateList().then(response => {
        console.log("fetchUsdtFiatCurrencyRateList: " + JSON.stringify(response));
        this.usdt2FiatCurrencyRateEntityList = response.data
      })
      .catch(err => {
        var errLog = JSON.stringify(err)
        alert(errLog);
        console.error("getUsdtFiatCurrencyRateList error: " + errLog);
      });
    },

    // getCurrentWallet() {
    //   tp.getCurrentWallet().then(res => {
    //     console.log("getCurrentWallet:"+JSON.stringify(res))
    //     if(res.result === true) {
    //       if(res.data.blockchain !== "eos") {
    //         alert("不支持网络" + res.data.blockchain);  
    //       }
    //       this.currentAccount = res.data.name
    //       this.currentPublicKey = res.data.address
    //       console.log('currentAccount:' + this.currentAccount)
    //       this.getEosBalance(this.currentAccount, this.contract, this.symbol)
    //     } else {
    //       alert(res.msg);
    //     }
        
    //   })
    //   .catch(err => {
    //       var errLog = JSON.stringify(err)
    //       alert(errLog);
    //       console.log("getCurrentWallet error: " + errLog);
    //   });
    // },

    getEosBalance(account, contract, symbol) {
      
      console.log('call rpc.get_currency_balance:'+ "account=" + account + "contract=" + contract + "symbol=" + symbol)
      rpc.get_currency_balance(contract, account, symbol).then(res => {
        console.log('getEosBalance:' + JSON.stringify(res))
        // 
        var amount = res[0].split(" ")
        this.currentBalance = amount[0]
        console.log('currentAccount:' + this.currentBalance)
        this.calcBalance()
      })
      .catch(err => {
        var errLog = JSON.stringify(err)
        // alert(errLog);
        console.error("getEosBalance error: " + errLog);
      });
    },

    transferToken(to, amount, memo) {
      
      console.log('call scatter.requestTransfer '+ ", to=" + to + ", amount=" + amount + ", memo=" + memo)
      const tokenDetails = {
        contract: this.contract,
        symbol: this.symbol,
        memo: memo,
        decimals: this.decimals
      };
      scatter.requestTransfer(network, to, amount, tokenDetails).then(res => {
        alert("支付成功");
        console.error("transferToken success" + JSON.stringify(res));
        Message({ message: '支付成功, 交易单号:' + res.transaction_id,
          type: 'info',
          // duration: 5 * 1000,
        })
      }).catch(err => {
        // alert("fail" + err);
        console.error("transferToken fail" + err);
      });
    },

    transfer: function(to, amount, memo) {
      console.log('call api.transact '+ ", to=" + to + ", amount=" + amount + ", memo=" + memo)
      var quantity = new BigNumber(amount).toFixed(this.decimals, 1)
      api.transact(
        {
          actions: [
            {
              account: this.contract,
              name: "transfer",
              authorization: [
                {
                  actor: this.currentAccount,
                  permission: this.currentPermission
                }
              ],
              data: {
                from: this.currentAccount,
                to: to,
                quantity: quantity + this.symbol,
                memo: memo,
              }
            }
          ]
        },
        {
          blocksBehind: 3,
          expireSeconds: 30
        }
      )
      .then(res => {
        alert("支付成功");
        console.log("transfer success" + JSON.stringify(res));
        Message({ message: '支付成功, 交易单号:' + res.transaction_id,
          type: 'info',
          // duration: 5 * 1000,
        })
      })
      .catch(err => {
        alert("transfer fail" + err);
        console.error("transfer fail" + err);
      }); 
    },

    getEosTransactionRecord(account) {
      var data = {
        start: 0,
        count: 10,
        account: account,
        token: this.symbol,
        sort: 'desc',
        contract: this.contract,
      }
      console.log('call tp.getEosTransactionRecord '+ "account=" + account)
      tp.getEosTransactionRecord(data).then(res => {
        console.log('getEosTransactionRecord:' + JSON.stringify(res))
        if(res.result === true) {
          Message({ message: JSON.stringify(res.data),
            type: 'info',
            duration: 5 * 1000,
          })
        }
      })
      .catch(err => {
        var errLog = JSON.stringify(err)
        alert(errLog);
        console.error("eosTokenTransfer error: " + errLog);
      });
    },

    onConvertChange() {
      console.log("select conver"+ this.coinPriceForm.convert)
      // this.coinPriceForm.convert = convert
      this.getCoinPrice(this.coinPriceForm)
    },

    // 扫码
    onScanQRcode() {
      console.log("call invokeQRScanner")
      if(tp.isConnected()) {
        tp.invokeQRScanner().then(res => {
          if(isString(res) && res.length > 12) {
            console.log('scan res:' + res)
            // {"symbol":"ZNL","protocol":"ScanProtocol","action":"transfer","precision":8,"blockchain":"EOS","amount":"0","contract":"zntzcontract","address":"dghhg321.mlt"}
            var jsonRes = JSON.parse(res)
            if(jsonRes.hasOwnProperty("address")) {
              res = jsonRes['address']
            }
          }
          this.transferForm.address = res
          console.log('scan address:' + res)
        })
        .catch(err => {
          var errLog = JSON.stringify(err)
          alert(errLog);
          console.error("invokeQRScanner error: " + errLog);
        });
      }
      if (TokenWebView.isTokenEnv()) {
        TokenWebView.apis.native.scanQRCode().then(res => {
          console.log('scan res:' + res)
          console.log('res isString: ' + isString(res).toString())

          if(isString(res) && res.length > 12) {
            // {"symbol":"ZNL","protocol":"ScanProtocol","action":"transfer","precision":8,"blockchain":"EOS","amount":"0","contract":"zntzcontract","address":"dghhg321.mlt"}
            var jsonRes = JSON.parse(res)
            if(jsonRes.hasOwnProperty("address")) {
              res = jsonRes['address']
            }
          } else if(typeof res === 'object') {
            if(jsonRes.hasOwnProperty("address")) {
              res = jsonRes['address']
            }
          }
          
          this.transferForm.address = res
          console.log('scan address:' + res)
        })
        .catch(err => {
          var errLog = JSON.stringify(err)
          alert(errLog);
          console.error("imToken scanQRCode error: " + errLog);
        });
      }
      
    },

    //支付
    onPay() {
      if(!isNumberStr(this.transferForm.money)) {
        alert("请输入正确数字");
        return
      }
      var amount = new BigNumber(this.transferForm.money).dividedBy(this.coinPriceEntity.price)
      if(amount.comparedTo('0') <= 0) {
        alert("请输入正确数字");
        return
      } else if(amount.comparedTo(this.currentBalance) == 1) {
        alert("数额不能超过最大金额")
        return
      }
      var memo = this.transferForm.memo
      // String defaultRemark = mCurrencyName + ": " + mCoinPriceEntity.getPrice() + mCoinPriceEntity.getConvert() + ", amount: " + transferCount + ", money: " + etTransfer.getText().toString();
      var memo = this.symbol + ": " + this.coinPriceEntity.price + this.coinPriceEntity.convert + ", amount: " + amount.toFixed(4, 1) + ", money: " + this.transferForm.money
      if(this.transferForm.memo !== '') {
        memo = this.transferForm.memo + ", " + memo
      }
      if(tp.isConnected()) {
        this.transferToken(this.transferForm.address, amount.toFixed(4, 1), memo)
      }
      if(TokenWebView.isTokenEnv()) {
        this.transfer(this.transferForm.address, amount.toFixed(4, 1), memo)
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-transfer-payment {
  background-color: #F2F4F5;
  /* orientation: vertical; */
  /* padding-top: 10px; */
}

.div-tranfer {
  display: inline-block;
  orientation: horizontal;
}

.input-label {
    display: inline-block;
    /* width: 130px; */
}

/* el-select  {
    width: 20px;
} */

el-input {
  width: 30px;
}
.input-with-select .el-input-group__prepend {
    background-color: #fff;
}

.el-select-dropdown {
  /* position: absolute !important;
  left: 0px !important;
  top: 0px !important; */
  background-color: #09162F;
  /* margin: 0px; */
  /* border:0px; */
  border: 1px solid #70A9FF;
  border-radius: 0px;
  position: fixed !important;
  top: 90px !important;
  left: 10px !important;
  opacity: .9 !important;
}

/* 修改单个的选项的样式 */
.el-select-dropdown__item{
  background-color: #F0F0F0;
  color:#09162F;
}

/* item选项的hover样式 */
.el-select-dropdown__item.hover, 
.el-select-dropdown__item:hover{
  color:#409eff;
  background: white;
}

/* 修改的是下拉框选项内容上方的尖角 */
.el-popper .popper__arrow, .el-popper .popper__arrow::after{
  display: none;
}

</style>
